import Input from "../../../../components/input";
import { ValidationMessages, ValidationPatterns } from "../../../../utils/validation";

const VerificationContent = ({
  pendingEmail,
  fallbackEmail,
  verificationCode,
  setVerificationCode,
  handleVerificationValidationChange,
  onResendCode
}) => {
  const displayEmail = pendingEmail || fallbackEmail;

  return (
    <>
      <p className="verification-info">
        {displayEmail} adresine gelen doğrulama kodunu giriniz.
      </p>
      <Input
        type="text"
        name="verificationCode"
        value={verificationCode}
        onChange={(e) => setVerificationCode(e.target.value)}
        placeholder="Doğrulama Kodu"
        icon="zmdi zmdi-check-circle"
        required
        validationRegex={ValidationPatterns.NOT_EMPTY}
        errorMessage={ValidationMessages.REQUIRED}
        onValidationChange={handleVerificationValidationChange}
      />
      <div className="text-right mt-2">
        <button
          type="button"
          className="btn btn-simple btn-warning btn-sm"
          onMouseDown={(e) => e.preventDefault()}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onResendCode();
          }}
          style={{ padding: '0 5px' }}
        >
          Kodu Tekrar Gönder
        </button>
      </div>
    </>
  );
};

export default VerificationContent;

